import {Injectable} from '@angular/core';

import {getApp} from '@angular/fire/app';
import {PageService} from '../../shared/_services/page.service';
import {ClientService} from '../../shared/_services/client.service';

// @ts-ignore
import {environment} from '@env/environment';
import {connectStorageEmulator, getStorage, ref, getDownloadURL, uploadBytes,deleteObject } from '@angular/fire/storage';

@Injectable()
export class ConsumerStorageService {
    storage: any;

    constructor(
        private pSvc: PageService
    ) {

        this.storage = getStorage(getApp(environment.appName));
        if (this.storage && environment.type === 'local' && this.storage?._settings?.host !== 'localhost:9199') {
            connectStorageEmulator(this.storage, 'localhost', 9199);
        }

    }

    async upload(filePath: string, file: File): Promise<string> {
        return new Promise((resolve, reject) => {

            const imageRef = ref(this.storage,filePath);
            uploadBytes(imageRef, file)
                .then(
                    async r => {
                        let downloadUrl: any = await getDownloadURL(imageRef);
                        resolve(downloadUrl?.split(/\?/)[0] + '?alt=media&t=' + Date.now());
                        this.pSvc.loading$.next(null);
                    },
                    err => {
                        this.pSvc.alert$.next(err);
                    }
                );

        });
    }

    async downloadAsBase64(url: string): Promise<{ content: string; type: string; size: number }> {
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const blob = await response.blob();
            const base64 = await this.blobToBase64(blob);
            const sizeMB = +(blob.size / 1024 / 1024).toFixed(2);

            return { content: base64, type: blob.type, size: sizeMB };
        } catch (error) {
            this.pSvc.alert$.next(error);
            throw error;
        }
    }

    private blobToBase64(blob: Blob): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve((reader.result as string).split(',')[1]);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    async delete(url: string): Promise<void> {
        try {
            const pathMatch = url.match(/\/o\/([^?]+)\?/);
            if (!pathMatch || !pathMatch[1]) {
                throw new Error('Invalid storage URL');
            }
            const filePath = decodeURIComponent(pathMatch[1]);
            const fileRef = ref(this.storage, filePath);

            await deleteObject(fileRef);
        } catch (error) {
            this.pSvc.alert$.next(error);
            throw error;
        }
    }
}
